// extracted by mini-css-extract-plugin
export default {"link":"accordion-link_link__W24ep"};